import React from 'react';

import { SelectableCode, SheetCode } from 'src/common/types/Codes';

import { useExportPDFMutation } from '../../common/apis/FlorenceApi';
import { SaveSheet } from '../../common/types/SaveSheet';

export const useExportPdf = () => {
  const [exportPdfTrigger, { status, data, isLoading }] =
    useExportPDFMutation();

  React.useEffect(() => {
    if (status === 'fulfilled' && data?.fileLink) {
      fetch(data.fileLink)
        .then((response) => response.blob())
        .then((blob) => {
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);

          // Replace extension with .pdf (if we have an extension)
          const fileName = data.fileName
            ? data.fileName.replace(/\.[^/.]+$/, '.pdf')
            : Date.now() + '.pdf';

          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(link.href);
        })
        .catch((error) => {
          console.error('Error downloading PDF:', error);
        });
    }
  }, [status, data]);

  const exportPdf = (sheet: SaveSheet, selectedCodes?: SelectableCode[]) => {
    if (!!!sheet) return;
    exportPdfTrigger({
      billingSheetId: sheet.sheetId ?? -1,
      searchText: sheet.scanText,
      sheetCodes: selectedCodes
        ? (selectedCodes as SheetCode[])
        : sheet.sheetCodes,
      clinicNoteResults: sheet.clinicNoteResults,
      aiOutput: sheet.aiOutput,
    });
  };

  return { exportPdf, exportIsLoading: isLoading };
};
